import React from 'react';
import { TableRow, TableCell, Checkbox, Chip, IconButton } from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';

const PagesTableRow = ({
    page,
    index,
    isSelected,
    onRowCheckboxClick,
    onMenuOpen,
}) => {
    const { i18n } = useTranslation();
    const isArabic = i18n.language === 'ar';

    return (
        <TableRow
            hover
            role="checkbox"
            aria-checked={isSelected}
            tabIndex={-1}
            key={page.id}
            selected={isSelected}
        >
            <TableCell padding="checkbox">
                <Checkbox
                    color="primary"
                    checked={isSelected}
                    onClick={(event) => onRowCheckboxClick(event, page.id)}
                />
            </TableCell>

            <TableCell align="center">{index + 1}</TableCell>

            <TableCell align={isArabic ? 'right' : 'left'}>
                {page?.title?.en || "---"}
            </TableCell>

            <TableCell align={isArabic ? 'right' : 'left'}>
                {page?.title?.ar || "---"}
            </TableCell>

            <TableCell align={isArabic ? 'right' : 'left'}>
                <Chip label={page.slug} size="small" variant="outlined" />
            </TableCell>

            <TableCell align="center">
                <Chip
                    label={page.is_published ? (isArabic ? 'نشط' : 'Active') : (isArabic ? 'غير نشط' : 'Inactive')}
                    color={page.is_published ? 'success' : 'default'}
                    size="small"
                />
            </TableCell>

            <TableCell align="center">
                {dayjs(page.created_at).format('YYYY-MM-DD')}
            </TableCell>

            <TableCell align="center">
                <IconButton onClick={(event) => onMenuOpen(event, page)}>
                    <MoreVertIcon />
                </IconButton>
            </TableCell>
        </TableRow>
    );
};

export default PagesTableRow;
